var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"klass-specifics"},[_c('h3',[_vm._v("Combat Feat")]),_vm._v(" "),_c('p',[_vm._v("As a Fighter, you gain a bonus combat feat")]),_vm._v(" "),_c('div',{staticClass:"content box-shadow text-center"},[_c('h4',{staticClass:"ntm"},[_vm._v("Select a combat feat.")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52fa99cf","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/klasses/Fighter.vue
// module id = 60
// module chunks = 0